export default __webpack_public_path__ + "static/access-a218298705ffbc7a52759333feafe58b.png";